// extracted by mini-css-extract-plugin
module.exports =  {"dialogContainer":"dialogContainer__WEqh5"};